import { FC } from 'react';
import { Col } from 'reactstrap';
import { FontAwesome } from 'Elements';
import styles from 'partials/homepage/card/top-job-card.module.scss';
import { useResponsive } from 'src/hooks/useResponsive';

interface Props {
	job: any;
}

export const CommunityPartnerTopJobCard: FC<Props> = ({ job }) => {
	const { isDesktopAndAbove } = useResponsive();

	return (
		<Col
			sm={6}
			md={4}
			className={`${isDesktopAndAbove && styles.colBox} mb-4`}>
			<article className={styles.card}>
				{job?.partnerLogo && (
					<div className="flex items-center justify-center m-auto">
						<img
							src={job?.partnerLogo}
							alt={job?.jobId}
							style={{
								height: '88px',
								objectFit: 'contain',
								display: 'block',
								margin: '0 auto 10px'
							}}
						/>
					</div>
				)}

				<div className="position-relative d-flex flex-column gap-2 w-100 mt-2">
					{job?.businessSectors && (
						<div className="d-flex gap-2 align-items-center mb-0">
							<FontAwesome
								icon="industry"
								size="1x"
								className="text-gray-3"
							/>
							<span className="text-gray-3 font-normal text-sm">
								{job?.businessSectors[0]?.title?.split('|')[1]}
							</span>
						</div>
					)}
					<h4 className="fs-6 fw-bold lh-base mb-0">{job?.title}</h4>
				</div>
			</article>
		</Col>
	);
};
